<template>
  <div
    class="AuthRegister"
    data-cy-id="register-stage-job-preferences"
    data-rmpdev-selector="update-user-form"
  >
    <h1 class="u-noMargin">
      Job Preferences
    </h1>
    <p>Almost there! Tell us what kind of job you’re looking for - so we know what to send you.</p>

    <transition>
      <div
        v-if="serverValidationErrors.fail"
        class="Notice Notice--danger"
      >
        <div class="Notice-copy">
          {{ serverValidationErrors.fail }}
        </div>
      </div>
    </transition>

    <form-autocomplete
      v-model="fields.jobTypes"
      :error="validateStatus({ field: v$.fields.jobTypes, serverKey: 'jobTypes', label: 'Job type' })"
      :manual-validate="validateAll"
      :items="jobTypes"
      :hint="hint"
      :close-on-select="false"
      label="What type of job are you interested in?"
      required
      multiple
      class="JobTypes-field"
      data-rmpdev-field-selector="jobTypes"
      data-cy-id="register-job-types"
      placeholder="Select a job type"
      @rmp:change="validateBlur({ field: v$.fields.jobTypes, serverKey: 'jobTypes' })"
    />

    <button
      :class="['Button Button--primary Button--long', {'is-loading' : ui.loading}]"
      data-cy-id="register-next"
      @click.prevent="updateUser"
    >
      Next
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import FormAutocomplete from '@/components/form/autocomplete-select';
import RegistrationStagesMixin from './registration-stages-mixin';

export default {

  components: {
    FormAutocomplete,
  },

  mixins: [RegistrationStagesMixin],
  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      fields: {
        jobRoles: [],
        jobTypes: [],
      },
      hint: {
        type: 'warning',
        hint: 'You may select more than one',
      },
    };
  },
  validations() {
    const rules = {
      fields: {
        jobTypes: {
          required,
        },
      },
    };

    return rules;
  },
  computed: {
    ...mapState('entities', {
      jobTypes: (state) => state.jobTypes,
    }),
    updatePayload() {
      return {
        jobTypes: this.fields.jobTypes.map((jobType) => jobType.id),
      };
    },
  },
  mounted() {
    Promise.all([
      this.getJobTypes(),
    ]).then(() => {});

    this.fields.jobTypes = this.user.jobTypes;
  },
  methods: {
    ...mapActions('entities', {
      getJobTypes: 'getJobTypes',
    }),
  },
};
</script>
<style scoped lang="scss">
  .Form-field Button {
    width: 100%;
  }
  .JobRoles-field, .JobTypes-field {
  .dropdown-toggle {
    height: auto !important;
  }
  }
</style>
